// removed by extract-text-webpack-plugin
module.exports = {"table":"WaitTable__table___zwob7","selected":"WaitTable__selected___3Z-Mr"};